import React from 'react';
import {
  FiGitBranch,
  FiLayers,
  FiMail,
  FiBriefcase,
  FiFileText,
  FiUsers,
  FiRepeat,
  FiFlag,
  FiGrid,
  FiShield,
} from 'react-icons/fi';
import ProductTaskPricing from '../ProductTaskPricing/ProductTaskPricing';
import './ProductTaskContent.css';

const ProductTaskContent = () => {
  const sixBoxes = [
    { title: 'No more follow ups', description: 'Avoid post-it and follow up calls. Automated reminders and KPI tracking. Communicate in one place.' },
    { title: 'Team Collaboration', description: 'Work together seamlessly with real-time updates, comments, and team communication.' },
    { title: 'Progress Tracking', description: 'Track task status, completion, and generate transactional statements.' },
    { title: 'Smart Reminders', description: 'Never miss a deadline with intelligent notifications and customizable reminder settings.' },
    { title: 'Repeatable work', description: 'Create one-time or repeating tasks and keep assignments visible across the team.' },
    { title: 'Secure & Private', description: 'Your data is protected with enterprise-grade security and privacy controls.' },
  ];

  const features = [
    { icon: <FiLayers />, text: 'Easy to create' },
    { icon: <FiGitBranch />, text: 'Branch/Department wise allocation' },
    { icon: <FiMail />, text: 'Email reminders' },
    { icon: <FiFileText />, text: 'Transaction statements' },
    { icon: <FiUsers />, text: 'Group wise task assignment' },
    { icon: <FiRepeat />, text: 'Repeatable tasks' },
    { icon: <FiFlag />, text: 'Prioritized tasks' },
    { icon: <FiGrid />, text: 'Customized views' },
    { icon: <FiShield />, text: 'User role based access control' },
    { icon: <FiBriefcase />, text: 'Link related work to flowdo Projects' },
  ];

  return (
    <>
      {/* Six boxes from home page */}
      <section className="product-task-six-boxes">
        <div className="container">
          <div className="features-grid">
            {sixBoxes.map((box, index) => (
              <div key={index} className="feature-card">
                <h3>{box.title}</h3>
                <p>{box.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features list */}
      <section className="product-task-features">
        <div className="container">
          <h2 className="product-task-features-title">Features</h2>
          <ul className="product-task-features-list">
            {features.map((feature, index) => (
              <li key={index}>
                <span className="product-task-feature-icon">{feature.icon}</span>
                <span className='text-muted'>{feature.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Prices - Subscription details without Select, with Subscribe Now */}
      <ProductTaskPricing />
    </>
  );
};

export default ProductTaskContent;
